import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    padding: theme.spacing(3),
  },
  title: {
    marginBottom: theme.spacing(2),
    fontWeight: 500,
    color: 'rgb(1, 70, 81)',
    fontSize: '0.875rem',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },
  businessName: {
    fontWeight: 600,
    fontSize: '1.25rem',
    marginBottom: theme.spacing(1),
    color: 'rgb(1, 70, 81)',
  },
  description: {
    color: theme.palette.text.secondary,
    whiteSpace: 'pre-line',
    fontSize: '0.875rem',
  },
  items: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    marginTop: theme.spacing(3),
  },
  item: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
  },
  itemInfo: {
    flex: 1,
    marginRight: theme.spacing(2),
  },
  itemName: {
    fontWeight: 500,
    fontSize: '0.9rem',
    color: theme.palette.text.primary,
  },
  itemDescription: {
    marginTop: theme.spacing(0.5),
    whiteSpace: 'pre-line',
    fontSize: '0.875rem',
    color: theme.palette.text.secondary,
  },
  itemPrice: {
    fontWeight: 500,
    fontSize: '0.9rem',
    color: theme.palette.text.primary,
  },
  divider: {
    margin: theme.spacing(3, 0),
    backgroundColor: theme.palette.divider,
  },
  total: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(3),
  },
  totalLabel: {
    fontWeight: 600,
    fontSize: '1rem',
    color: 'rgb(1, 70, 81)',
  },
  totalAmount: {
    fontWeight: 600,
    fontSize: '1.25rem',
    color: 'rgb(1, 70, 81)',
  },
  status: {
    textAlign: 'center',
    marginBottom: theme.spacing(3),
    color: theme.palette.primary.main,
    fontSize: '0.875rem',
    fontWeight: 500,
  },
  createdAt: {
    display: 'block',
    textAlign: 'center',
    color: theme.palette.text.secondary,
    fontSize: '0.75rem',
    marginTop: theme.spacing(3),
  },
  createdBy: {
    marginLeft: theme.spacing(0.5),
    fontWeight: 500,
  },
}));
